import { EventEmitter, Injectable, Output } from '@angular/core';
import { DashboardFilter } from '../../../shared/models/company/dashboardFilter';

@Injectable()
export class DashboardComunicationService {

  @Output() readonly filter: EventEmitter<any> = new EventEmitter();

  applyFilter(filter: DashboardFilter, filterForView: any): void {
    this.filter.emit({ filter, filterForView});
  }

}
